import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const SettingsLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Define the tab configurations
  const tabs = [
    { label: "Profile Details", path: "/dashboard/settings" },
    { label: "Password", path: "/dashboard/settings/profile/change-password" },
    // { label: "Withdrawal accounts", path: "/dashboard/settings/profile/withdrawal-account" },
  ];

  // Get the active tab index based on the current route
  const activeIndex = tabs.findIndex((tab) => location.pathname === tab.path);

  const handleTabChange = (e: any) => {
    navigate(tabs[e.index].path);
  };

  return (
    <TabView activeIndex={activeIndex} onTabChange={handleTabChange}>
      {tabs.map((tab, index) => (
        <TabPanel key={index} header={tab.label}>
          <Outlet />
        </TabPanel>
      ))}
    </TabView>
  );
};

export default SettingsLayout;
